export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  apiBase: import.meta.env.VITE_API_BASE || '/api',
  betaMode: import.meta.env.VITE_BETA_MODE === 'true',
  featureTeamMembers: import.meta.env.VITE_FEATURE_TEAM_MEMBERS === 'true',
} as const
